import { Box, Heading, Input, InputGroup, InputRightElement, Link, List, ListItem } from "@chakra-ui/react"
import NextLink from "next/link"
import { useRouter, useSearchParams, } from "next/navigation"
import { useEffect, useState } from "react"
import { FaSearch } from "react-icons/fa"

const breakPoints = ['100%', '100%', '100%', '50%']

const BlogCategoriesList = (props: any) => {
    const queryParam = useSearchParams()
    const router = useRouter()
    const [term, setTerm] = useState<string>(queryParam.has('s') ? queryParam.get('s')! : '')
    const { categories } = props

    useEffect(() => {
        setTerm(queryParam.has('s') ? queryParam.get('s')! : '')
    }, [queryParam])


    const searchByText = (event: any) => {
        if (event.key === 'Enter') {
            router.push(`/noticias?s=${term}`)
        }
    }

    const isSelected = (slug:string) => {
        return slug === queryParam.get('category')
    }

    return (
        <Box p={4} boxShadow={'lg'} position={'sticky'} top={'160px'}>
            <Box>
                <InputGroup>
                    <Input
                        variant={'filled'}
                        value={term}
                        onChange={(e) => setTerm(e.currentTarget.value)}
                        placeholder="Buscar..."
                        onKeyDown={searchByText} />
                    <InputRightElement>
                        <FaSearch />
                    </InputRightElement>
                </InputGroup>
            </Box>
            <Heading as={'h6'} fontSize={18} my={8}>Categorias</Heading>
            <List>
                {categories.map((category: any, index: number) => {

                    return (
                        <ListItem key={index} fontSize={'14px'} p={'5px 0'} fontWeight={isSelected(category?.attributes?.Slug) ? '600':'400'} lineHeight={1.65}>
                            <Link prefetch as={NextLink}
                                href={`/noticias?category=${category?.attributes?.Slug}`}
                                me={1}
                                _hover={{ color: '#d90a2c', transition: 'all cubic-bezier(.4, 0, .2, 1) .4s' }}>
                                {category?.attributes?.Nome} 
                            </Link>
                            ({category?.attributes?.relatedPostsCount})
                        </ListItem>
                    )
                })}
            </List>
        </Box>

    )
}

export default BlogCategoriesList